module.exports = __webpack_public_path__ + "static/media/TableScratch2_After.02abffe3.jpg";